// Local translations
export const T = {
  en_GB: {
    labelLabel: "Label",
    descriptionLabel: "Description (optional)",
    descriptionPlaceholder: "Optional card description",
    iconLabel: "Icon",
    cancel: "Cancel",
    save: "Save",
  },
  nb_NO: {
    labelLabel: "Etikett",
    descriptionLabel: "Beskrivelse (valgfritt)",
    descriptionPlaceholder: "Valgfri kortbeskrivelse",
    iconLabel: "Ikon",
    cancel: "Avbryt",
    save: "Lagre",
  },
} as const;
